module.exports = __webpack_public_path__ + "static/media/bg-left.d4552700.png";